// extracted by mini-css-extract-plugin
export default {"pageLoading":"PageLoading_pageLoading__eISem","spinnerBorder":"PageLoading_spinnerBorder__m4tNq","spinner-border":"PageLoading_spinner-border__7n2Ji"};